module.exports = __webpack_public_path__ + "static/media/Cassiopeia_0.93650214.jpg";